(() => {
  function stampGiftParent(form) {
    if (!(form instanceof HTMLFormElement)) return;
    const field = form.querySelector('[data-canta-gift-added-at]');
    if (field && !field.value) field.value = String(Date.now());
  }

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('button[type="submit"]')
      : null;
    if (button) stampGiftParent(button.form);
  }, true);

  document.addEventListener('submit', (event) => {
    stampGiftParent(event.target);
  }, true);
})();
